import type { Vif } from '../vif';
import MetadataProvider from './MetadataProvider';
import SoqlDataProvider from './SoqlDataProvider';

export const getSoqlMetaBundle = (vif: Vif) => {
  const soqlDataProvider = SoqlDataProvider.fromVif(vif);
  const metadataProvider = MetadataProvider.fromVif(vif);
  return { soqlDataProvider, metadataProvider };
};
